import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { mapState } from 'vuex';
import { CURRENCIES } from '@/store/modules/common/mutation-types';
import { FieldOptionTransformer } from "@/transformers/FieldOptionTransformer";
import KivaProxy from "@/utils/kivaProxy/src";
export default {
  data: function data() {
    return {
      dealTypes: [],
      leadSource: [],
      closedReasons: [],
      stages: [],
      tags: []
    };
  },
  computed: _objectSpread({}, mapState('common', {
    'currencies': CURRENCIES
  })),
  methods: {
    getStages: function getStages() {
      var _this = this;
      new KivaProxy({
        endpoint: "crm/deal/stage/options"
      }).all().then(function (response) {
        _this.stages = FieldOptionTransformer.fetchCollection(response.records);
      });
    },
    getDealType: function getDealType() {
      var _this2 = this;
      new KivaProxy({
        endpoint: "crm/deal/type/options"
      }).all().then(function (response) {
        _this2.dealTypes = FieldOptionTransformer.fetchCollection(response.records);
      });
    },
    getLeadSource: function getLeadSource() {
      var _this3 = this;
      new KivaProxy({
        endpoint: "crm/deal/lead_source/options"
      }).all().then(function (response) {
        _this3.leadSource = FieldOptionTransformer.fetchCollection(response.records);
      });
    },
    getTags: function getTags() {
      var _this4 = this;
      new KivaProxy({
        endpoint: "crm/deal/tags/options"
      }).all().then(function (response) {
        _this4.tags = FieldOptionTransformer.fetchCollection(response.records);
      });
    },
    getClosedReasons: function getClosedReasons(search) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new KivaProxy({
                endpoint: "crm/deal/closed_reason/options"
              }).all().then(function (response) {
                var closedReasons = FieldOptionTransformer.fetchCollection(response.records);
                if (search) {
                  _this5.closedReasons = closedReasons.filter(function (k) {
                    return k.special.includes(search);
                  });
                } else {
                  _this5.closedReasons = closedReasons;
                }
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    findClosedReason: function findClosedReason(data) {
      var search = data.stage == 7 ? 'LOST' : data.stage == 6 ? 'WON' : null;
      if (search) {
        return this.closedReasons.filter(function (k) {
          return k.special.includes(search);
        });
      }
      return [];
    }
  }
};